// extracted by mini-css-extract-plugin
export default {"siteWide":"header-wrapper-siteWide--5d435","headerContainer":"header-wrapper-headerContainer--0ea26"};